// import React from "react";
// import { Label } from "../../../../Components/ui/label";
// import {
//   Select,
//   SelectTrigger,
//   SelectValue,
//   SelectContent,
//   SelectItem,
// } from "../../../../Components/ui/select";
// import { Input } from "../../../../Components/ui/input";
// import {
//   Accordion,
//   AccordionItem,
//   AccordionTrigger,
//   AccordionContent,
// } from "../../../../Components/ui/accordion";

// interface CountryRoamingDaysAccordionProps {
//   countryName: string;
//   countryISO: string;
//   roamingDayConfig: {
//     condition_a: { con_operator: string; value: number };
//     condition_b: { con_operator: string; value: number } | null;
//   };
//   onUpdate: (
//     iso: string,
//     config: {
//       condition_a: { con_operator: string; value: number };
//       condition_b: { con_operator: string; value: number } | null;
//     }
//   ) => void;
//   isViewMode: boolean;
// }

// const CountryRoamingDaysAccordion: React.FC<CountryRoamingDaysAccordionProps> = ({
//   countryName,
//   countryISO,
//   roamingDayConfig,
//   onUpdate,
//   isViewMode,
// }) => {
//   const CONDITION_A_OPTIONS = [
//     { value: ">", label: "Greater Than" },
//     { value: ">=", label: "Greater Than Equal To" },
//     { value: "=", label: "Equal To" },
//   ];

//   const CONDITION_B_OPTIONS = [
//     { value: "<", label: "Lesser Than" },
//     { value: "<=", label: "Lesser Than Equal To" },
//   ];

//   const handleConditionAOperatorChange = (operator: string) => {
//     const currentValue = roamingDayConfig.condition_a.value;

//     if (operator === "=") {
//       // If Equal To is selected, disable condition_b
//       onUpdate(countryISO, {
//         condition_a: { con_operator: operator, value: currentValue },
//         condition_b: null,
//       });
//     } else {
//       // For > or >=, ensure condition_b exists
//       const minConditionBValue = currentValue + 2;
//       const conditionBValue =
//         roamingDayConfig.condition_b?.value || minConditionBValue;

//       onUpdate(countryISO, {
//         condition_a: { con_operator: operator, value: currentValue },
//         condition_b: {
//           con_operator: roamingDayConfig.condition_b?.con_operator || "<=",
//           value: conditionBValue < minConditionBValue ? minConditionBValue : conditionBValue,
//         },
//       });
//     }
//   };

//   const handleConditionAValueChange = (value: string) => {
//     if (value === "") {
//       onUpdate(countryISO, {
//         ...roamingDayConfig,
//         condition_a: { ...roamingDayConfig.condition_a, value: 0 },
//       });
//       return;
//     }

//     let num = Number(value);
//     if (num < 0) num = 0;
//     if (num > 30) num = 30;

//     const minConditionBValue = num + 2;

//     // Auto-adjust condition_b if needed
//     if (roamingDayConfig.condition_b) {
//       const currentConditionBValue = roamingDayConfig.condition_b.value;
      
//       onUpdate(countryISO, {
//         condition_a: { ...roamingDayConfig.condition_a, value: num },
//         condition_b: {
//           ...roamingDayConfig.condition_b,
//           value:
//             currentConditionBValue < minConditionBValue
//               ? minConditionBValue > 30
//                 ? 30
//                 : minConditionBValue
//               : currentConditionBValue,
//         },
//       });
//     } else {
//       onUpdate(countryISO, {
//         ...roamingDayConfig,
//         condition_a: { ...roamingDayConfig.condition_a, value: num },
//       });
//     }
//   };

//   const handleConditionBOperatorChange = (operator: string) => {
//     if (!roamingDayConfig.condition_b) return;

//     onUpdate(countryISO, {
//       ...roamingDayConfig,
//       condition_b: {
//         ...roamingDayConfig.condition_b,
//         con_operator: operator,
//       },
//     });
//   };

//   const handleConditionBValueChange = (value: string) => {
//     if (!roamingDayConfig.condition_b) return;

//     // Allow empty or numeric input during typing
//     if (value === "" || /^\d+$/.test(value)) {
//       onUpdate(countryISO, {
//         ...roamingDayConfig,
//         condition_b: {
//           ...roamingDayConfig.condition_b,
//           value: value === "" ? 0 : Number(value),
//         },
//       });
//     }
//   };

//   const handleConditionBValueBlur = (value: string) => {
//     if (!roamingDayConfig.condition_b) return;

//     const minValue = roamingDayConfig.condition_a.value + 2;

//     if (value === "") {
//       onUpdate(countryISO, {
//         ...roamingDayConfig,
//         condition_b: {
//           ...roamingDayConfig.condition_b,
//           value: minValue,
//         },
//       });
//       return;
//     }

//     let num = Number(value);
//     if (num < minValue) num = minValue;
//     if (num > 30) num = 30;

//     onUpdate(countryISO, {
//       ...roamingDayConfig,
//       condition_b: {
//         ...roamingDayConfig.condition_b,
//         value: num,
//       },
//     });
//   };

//   const MIN_CONDITION_B_VALUE = roamingDayConfig.condition_a.value + 2;
//   const noValidConditionB = MIN_CONDITION_B_VALUE > 30;
//   const showConditionB =
//     roamingDayConfig.condition_a.con_operator !== "=" && !noValidConditionB;

//   return (
//     <AccordionItem value={countryISO} className="border-b">
//       <AccordionTrigger className="text-sm font-medium text-[#020617] hover:no-underline">
//         {countryName}
//       </AccordionTrigger>
//       <AccordionContent>
//         {/* CONDITION A - Greater Than */}
//         <div className="mt-2">
//           <Label className="text-xs text-[#64748B]">Greater than</Label>
//           <div className="flex items-center gap-3 mt-1">
//             <Select
//               disabled={isViewMode}
//               value={roamingDayConfig.condition_a.con_operator}
//               onValueChange={handleConditionAOperatorChange}
//             >
//               <SelectTrigger className="w-48 text-sm">
//                 <SelectValue placeholder="Select" />
//               </SelectTrigger>
//               <SelectContent>
//                 {CONDITION_A_OPTIONS.map((opt) => (
//                   <SelectItem key={opt.value} value={opt.value}>
//                     {opt.label}
//                   </SelectItem>
//                 ))}
//               </SelectContent>
//             </Select>

//             <Input
//               type="number"
//               disabled={isViewMode}
//               className="w-40"
//               min={0}
//               max={30}
//               value={roamingDayConfig.condition_a.value}
//               onChange={(e) => handleConditionAValueChange(e.target.value)}
//             />
//           </div>
//         </div>

//         {/* AND DIVIDER */}
//         {showConditionB && roamingDayConfig.condition_b && (
//           <div className="mt-3">
//             <button
//               className="px-4 py-1 bg-gray-200 rounded text-sm cursor-not-allowed"
//               disabled
//             >
//               AND
//             </button>
//           </div>
//         )}

//         {/* CONDITION B - Lesser Than */}
//         {showConditionB && roamingDayConfig.condition_b && (
//           <div className="mt-3">
//             <Label className="text-xs text-[#64748B]">Lesser than</Label>
//             <div className="flex items-center gap-3 mt-1">
//               <Select
//                 value={roamingDayConfig.condition_b.con_operator}
//                 disabled={isViewMode}
//                 onValueChange={handleConditionBOperatorChange}
//               >
//                 <SelectTrigger className="w-48 text-sm">
//                   <SelectValue placeholder="Select" />
//                 </SelectTrigger>
//                 <SelectContent>
//                   {CONDITION_B_OPTIONS.map((opt) => (
//                     <SelectItem key={opt.value} value={opt.value}>
//                       {opt.label}
//                     </SelectItem>
//                   ))}
//                 </SelectContent>
//               </Select>

//               <Input
//                 type="number"
//                 className="w-40"
//                 disabled={isViewMode}
//                 min={MIN_CONDITION_B_VALUE}
//                 max={30}
//                 value={roamingDayConfig.condition_b.value}
//                 onChange={(e) => handleConditionBValueChange(e.target.value)}
//                 onBlur={(e) => handleConditionBValueBlur(e.target.value)}
//               />
//             </div>
//           </div>
//         )}

//         {/* NO VALID RANGE WARNING */}
//         {roamingDayConfig.condition_a.con_operator !== "=" && noValidConditionB && (
//           <p className="text-red-600 text-sm mt-3">
//             No valid range exists after {roamingDayConfig.condition_a.value}. Please reduce
//             the first value.
//           </p>
//         )}
//       </AccordionContent>
//     </AccordionItem>
//   );
// };

// export default CountryRoamingDaysAccordion;


import React, { useState } from "react";
import { Label } from "../../../../Components/ui/label";
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from "../../../../Components/ui/select";
import { Input } from "../../../../Components/ui/input";
import {
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "../../../../Components/ui/accordion";

interface CountryRoamingDaysAccordionProps {
  countryName: string;
  countryISO: string;
  roamingDayConfig: {
    condition_a: { con_operator: string; value: number };
    condition_b: { con_operator: string; value: number } | null;
  };
  onUpdate: (
    iso: string,
    config: {
      condition_a: { con_operator: string; value: number };
      condition_b: { con_operator: string; value: number } | null;
    }
  ) => void;
  isViewMode: boolean;
}

const CountryRoamingDaysAccordion: React.FC<CountryRoamingDaysAccordionProps> = ({
  countryName,
  countryISO,
  roamingDayConfig,
  onUpdate,
  isViewMode,
}) => {
  const [conditionAError, setConditionAError] = useState<string>("");
  const [conditionBError, setConditionBError] = useState<string>("");

  const CONDITION_A_OPTIONS = [
    { value: ">", label: "Greater Than" },
    { value: ">=", label: "Greater Than Equal To" },
    { value: "=", label: "Equal To" },
  ];

  const CONDITION_B_OPTIONS = [
    { value: "<", label: "Lesser Than" },
    { value: "<=", label: "Lesser Than Equal To" },
  ];

  const handleConditionAOperatorChange = (operator: string) => {
    const currentValue = roamingDayConfig.condition_a.value;
    setConditionAError("");
    setConditionBError("");

    if (operator === "=") {
      onUpdate(countryISO, {
        condition_a: { con_operator: operator, value: currentValue },
        condition_b: null,
      });
    } else {
      onUpdate(countryISO, {
        condition_a: { con_operator: operator, value: currentValue },
        condition_b: roamingDayConfig.condition_b ?? {
          con_operator: "<=",
          value: 30,
        },
      });
    }
  };
const handleConditionAValueChange = (value: string) => {
    if (value === "") {
      setConditionAError("");
      onUpdate(countryISO, {
        ...roamingDayConfig,
        condition_a: { ...roamingDayConfig.condition_a, value: 0 },
      });
      return;
    }

    const num = Number(value);

    if (num < 0 || num > 30) {
      setConditionAError("Value must be between 0 and 30");
    } else if (roamingDayConfig.condition_b && num > roamingDayConfig.condition_b.value - 2) {
      setConditionAError("Value must be at least 2 less than the second condition value");
    } else {
      setConditionAError("");
    }

    // Re-validate condition_b against the new condition_a value
    if (roamingDayConfig.condition_b) {
      const conditionBValue = roamingDayConfig.condition_b.value;
      
      if (conditionBValue < 0 || conditionBValue > 30) {
        setConditionBError("Value must be between 0 and 30");
      } else if (conditionBValue < num + 2) {
        setConditionBError("Value must be at least 2 greater than the first condition value");
      } else {
        setConditionBError(""); // Clear error if condition_b is now valid
      }
    }

    onUpdate(countryISO, {
      ...roamingDayConfig,
      condition_a: { ...roamingDayConfig.condition_a, value: num },
    });
  };

  const handleConditionBOperatorChange = (operator: string) => {
    if (!roamingDayConfig.condition_b) return;
    setConditionBError("");

    onUpdate(countryISO, {
      ...roamingDayConfig,
      condition_b: {
        ...roamingDayConfig.condition_b,
        con_operator: operator,
      },
    });
  };
const handleConditionBValueChange = (value: string) => {
    if (!roamingDayConfig.condition_b) return;

    if (value === "") {
      setConditionBError("");
      onUpdate(countryISO, {
        ...roamingDayConfig,
        condition_b: {
          ...roamingDayConfig.condition_b,
          value: 0,
        },
      });
      return;
    }

    const num = Number(value);

    if (num < 0 || num > 30) {
      setConditionBError("Value must be between 0 and 30");
    } else if (num < roamingDayConfig.condition_a.value + 2) {
      setConditionBError("Value must be at least 2 greater than the first condition value");
    } else {
      setConditionBError("");
    }

    // Re-validate condition_a against the new condition_b value
    const conditionAValue = roamingDayConfig.condition_a.value;
    
    if (conditionAValue < 0 || conditionAValue > 30) {
      setConditionAError("Value must be between 0 and 30");
    } else if (conditionAValue > num - 2) {
      setConditionAError("Value must be at least 2 less than the second condition value");
    } else {
      setConditionAError(""); // Clear error if condition_a is now valid
    }

    onUpdate(countryISO, {
      ...roamingDayConfig,
      condition_b: {
        ...roamingDayConfig.condition_b,
        value: num,
      },
    });
  };

  const showConditionB = roamingDayConfig.condition_a.con_operator !== "=";

  return (
    <AccordionItem value={countryISO} className="border-b last:border-b-0">
      <AccordionTrigger className="text-sm font-normal text-[#475569] hover:no-underline py-2">
        {countryName}
      </AccordionTrigger>
      <AccordionContent>
        {/* CONDITION A */}
        <div className="mt-2">
          <Label className="text-xs text-[#64748B]">Greater than</Label>
          <div className="flex items-center gap-3 mt-1">
            <Select
              disabled={isViewMode}
              value={roamingDayConfig.condition_a.con_operator}
              onValueChange={handleConditionAOperatorChange}
            >
              <SelectTrigger className="w-48 text-sm">
                <SelectValue placeholder="Select" />
              </SelectTrigger>
              <SelectContent>
                {CONDITION_A_OPTIONS.map((opt) => (
                  <SelectItem key={opt.value} value={opt.value}>
                    {opt.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>

            <Input
              type="text"
              disabled={isViewMode}
              className="w-40"
              min={0}
              max={30}
              value={roamingDayConfig.condition_a.value}
              onChange={(e) => handleConditionAValueChange(e.target.value)}
              onWheel={(e) => e.currentTarget.blur()}
            />
          </div>
          {conditionAError && (
            <p className="text-red-500 text-xs mt-1">{conditionAError}</p>
          )}
        </div>

        {/* AND DIVIDER */}
        {showConditionB && roamingDayConfig.condition_b && (
          <div className="mt-3">
            <button
              className="px-4 py-1 bg-gray-200 rounded text-sm cursor-not-allowed"
              disabled
            >
              AND
            </button>
          </div>
        )}

        {/* CONDITION B */}
        {showConditionB && roamingDayConfig.condition_b && (
          <div className="mt-3">
            <Label className="text-xs text-[#64748B]">Lesser than</Label>
            <div className="flex items-center gap-3 mt-1">
              <Select
                value={roamingDayConfig.condition_b.con_operator}
                disabled={isViewMode}
                onValueChange={handleConditionBOperatorChange}
              >
                <SelectTrigger className="w-48 text-sm">
                  <SelectValue placeholder="Select" />
                </SelectTrigger>
                <SelectContent>
                  {CONDITION_B_OPTIONS.map((opt) => (
                    <SelectItem key={opt.value} value={opt.value}>
                      {opt.label}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>

              <Input
                type="text"
                className="w-40"
                disabled={isViewMode}
                min={0}
                max={30}
                value={roamingDayConfig.condition_b.value}
                onChange={(e) => handleConditionBValueChange(e.target.value)}
                onWheel={(e) => e.currentTarget.blur()}
              />
            </div>
            {conditionBError && (
              <p className="text-red-500 text-xs mt-1">{conditionBError}</p>
            )}
          </div>
        )}
      </AccordionContent>
    </AccordionItem>
  );
};

export default CountryRoamingDaysAccordion;